import React, { ChangeEvent } from "react";
import "./ChordEditNoteRow.css";
import { MusicNoteWithinChord } from "../../../../wasm/pkg/wasm";
import { printNoteName } from "../../../models/wasm.model";

export type NoteEditMeta = {
  note: MusicNoteWithinChord;
  isSounded: boolean;
  isBassNote: boolean; // there can only be one!
};

interface Props {
  meta: NoteEditMeta;
  checkboxUniqueId: string;
  /** radio buttons sharing a name so that only 1 can be checked at a time */
  radioBassSharedId: string;
  onToggleAudibility: () => void;
  onSelectBassNote: () => void;
}

function ChordEditNoteRow(props: Props) {
  const {
    checkboxUniqueId,
    radioBassSharedId,
    meta: { note, isSounded, isBassNote },
  } = props;
  const labelText = printNoteName(note.note_name);

  const handleToggleAudibility = (event: ChangeEvent<HTMLInputElement>) => {
    props.onToggleAudibility();
  };
  const handleChangeBass = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      props.onSelectBassNote();
    }
  };

  return (
    <>
      <label className="chord-edit-note-label" htmlFor={checkboxUniqueId}>
        {labelText}
        <input
          type="checkbox"
          className="chord-edit-note-sounded-input"
          id={checkboxUniqueId}
          checked={isSounded}
          onChange={handleToggleAudibility}
        ></input>
      </label>
      <div className="chord-edit-note-interval">({note.interval.chord_int})</div>
      <input
        type="radio"
        className="chord-edit-note-bass-input"
        name={radioBassSharedId}
        checked={isBassNote}
        onChange={handleChangeBass}
      />
    </>
  );
}

export default ChordEditNoteRow;
